import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { Button, Colors, Text } from '@mercator-gcp/grout';
import SuggestCorrectionModal from 'components/widgets/SuggestCorrection/Modal';

const fixedFooterStyle = {
  position: 'fixed',
  bottom: (theme: any) => theme.space.sixteen,
  left: (theme: any) => theme.space.fortyEight,
  display: 'flex',
  flexDirection: 'column',
  gap: 'padding_4',
  zIndex: 10,
};

const inlineFooterStyle = {
  display: 'flex',
  gap: 'padding_4',
  alignItems: 'center',
  justifyContent: 'center',
};

const suggestCorrectionTextStyle = {
  fontSize: '13px',
  lineHeight: '21px',
  letterSpacing: '-0.13px',
  color: Colors.TextQuiet,
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
};

const suggestCorrectionButtonStyle = {
  display: 'inline',
  padding: 0,
  height: 'auto',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  textAlign: 'left',
  _hover: {
    background: 'transparent',
  },
};

const suggestCorrectionLinkTextStyle = {
  fontSize: '13px',
  lineHeight: '1.26',
  letterSpacing: '-0.13px',
  color: Colors.TextQuiet,
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  textDecoration: 'underline',
};

type SuggestCorrectionFooterProps = {
  projectId?: number;
  companyId?: string;
  variant?: 'fixed' | 'inline';
};

const SuggestCorrectionFooter = ({
  projectId,
  companyId,
  variant = 'fixed',
}: SuggestCorrectionFooterProps) => {
  const [isSuggestCorrectionModalOpen, setIsSuggestCorrectionModalOpen] = useState(false);
  const footerStyle = variant === 'inline' ? inlineFooterStyle : fixedFooterStyle;

  return (
    <>
      <Box sx={footerStyle}>
        <Text sx={suggestCorrectionTextStyle}>AI isn&apos;t perfect.</Text>
        <Button
          variant="unstyled"
          onClick={() => setIsSuggestCorrectionModalOpen(true)}
          sx={suggestCorrectionButtonStyle}
        >
          <Text sx={suggestCorrectionLinkTextStyle}>Suggest a correction</Text>
        </Button>
      </Box>
      <SuggestCorrectionModal
        isOpen={isSuggestCorrectionModalOpen}
        onClose={() => setIsSuggestCorrectionModalOpen(false)}
        projectId={projectId}
        companyId={companyId}
      />
    </>
  );
};

export default SuggestCorrectionFooter;
